__turbopack_context__.v({
  "quality-seal-button": "brandvideo-module-scss-module__u9CLQq__quality-seal-button",
  "quality-seal-dialog-link": "brandvideo-module-scss-module__u9CLQq__quality-seal-dialog-link",
  "quality-seal-video-frame": "brandvideo-module-scss-module__u9CLQq__quality-seal-video-frame",
});
